import React from "react"
import { ContentfulMarkdownOverrideContext } from "#/services/contentful/contentful-markdown-renderer"
import type { ContentfulContentEntry } from "#/services/contentful/contentful-content-renderer"
import { LinkModalContextProvider } from "#/services/contentful/custom-components"
import { CarrotMatchContextProvider } from "#/components/carrot-match-fertility-clinic-precision-matching/context/CarrotMatchContext"
import { useFilteredContent } from "./use-filtered-content"
import { ContentList } from "../content-types/content-item"
import type { MarkdownProps } from "#/services/markdown"
import { ContentNode } from "#/services/contentful/renderer/types"

type ContentMarkdownOverrides = Omit<MarkdownProps, "children">

export interface ContentRendererProps extends ContentMarkdownOverrides {
  contents: ContentNode[]
  asList?: boolean
  allowConditionsOverride?: boolean
}

interface ContentRendererForContentfulEntriesProps extends Omit<ContentRendererProps, "contents"> {
  contentfulEntries: ContentfulContentEntry[]
}

// Once we migrate to the new renderer, we should move the contents of this file to src/services/contentful/content-renderer.tsx
export function ContentRendererForContentfulEntries({
  contentfulEntries,
  asList,
  allowConditionsOverride,
  ...markdownProps
}: ContentRendererForContentfulEntriesProps) {
  const { content, isLoading } = useFilteredContent(contentfulEntries, allowConditionsOverride)

  if (isLoading) return null

  return <ContentRenderer contents={content} asList={asList} {...markdownProps} />
}

function ContentRenderer({ contents, asList, ...markdownProps }: ContentRendererProps) {
  return (
    <ContentfulMarkdownOverrideContext.Provider value={markdownProps || {}}>
      <LinkModalContextProvider>
        <CarrotMatchContextProvider>
          <ContentList contents={contents} asList={asList} />
        </CarrotMatchContextProvider>
      </LinkModalContextProvider>
    </ContentfulMarkdownOverrideContext.Provider>
  )
}
